import { connect } from 'react-redux'
import SamplesTab from '../../components/FieldsComponents/SamplesTab'
import { getSelectedSample } from '../../selectors/samples'

const mapStateToProps = state => ({
  selectedSample: getSelectedSample(state)
})

export default connect(mapStateToProps, null)(SamplesTab)
